export const ERROR_CODE_MAP: { [key: string]: string } = {
  VALIDATION_ERROR: 'Validation failed. Please check your input.',
  DATABASE_ERROR: 'A database error occurred. Please try again later.',
  SCHEMA_ALREADY_EXISTS: 'The schema already exists.',
  SCHEMA_CREATION_FAILED: 'Failed to create the schema. Please contact support.',
  SCHEMA_MIGRATION_FAILED: 'Schema migration failed. Please contact support.',
  INTERNAL_SERVER_ERROR: 'An unexpected error occurred. Please try again later.',
};
